import {
  ChangeEvent,
  ClassAttributes,
  FocusEvent,
  InputHTMLAttributes,
  ReactNode,
  useEffect,
  useState,
} from "react";
import { FieldHookConfig, useField } from "formik";
import { InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

export interface CurrencyFormControlProps {
  children?: ReactNode;
}

const CurrencyFormControl = ({
  children,
  onChange,
  ...props
}: CurrencyFormControlProps &
  InputHTMLAttributes<HTMLInputElement> &
  ClassAttributes<HTMLInputElement> &
  FieldHookConfig<number | undefined>) => {
  const [{ value, onBlur, ...field }, { error }, { setValue }] =
    useField(props);

  const [displayValue, setDisplayValue] = useState(
    value ? Number(value).toFixed(2) : ""
  );

  useEffect(() => {
    var displayValue = value ? Number(value).toFixed(2) : "";
    setDisplayValue(displayValue);
  }, [value]);

  const formatValue = (value: string): string => {
    if (
      value.indexOf(".") > 0 &&
      value.substring(value.indexOf(".") + 1).length > 2
    ) {
      return (Math.floor(Number(value) * 100) / 100).toFixed(2);
    }
    return value;
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const displayValue =
      e.target.value !== "" ? formatValue(e.target.value) : "";
    setDisplayValue(displayValue);
    onChange && onChange(e);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    const displayValue =
      e.target.value !== "" ? Number(e.target.value).toFixed(2) : "";
    const value =
      e.target.value !== ""
        ? Math.round(Number(e.target.value) * 100) / 100
        : undefined;
    setDisplayValue(displayValue);
    setValue(value);
    onBlur(e);
  };

  return (
    <>
      <InputGroup size="sm" className="flex-nowrap">
        <InputGroup.Text>£</InputGroup.Text>
        <input
          {...field}
          {...props}
          value={displayValue}
          type="number"
          onChange={handleChange}
          onBlur={handleBlur}
          className="form-control"
          style={{ width: 60 }}
        />
        {error && (
          <div className="input-group-text text-danger" title={error}>
            <FontAwesomeIcon icon={faWarning} />
          </div>
        )}
        <>{children}</>
      </InputGroup>
    </>
  );
};

export default CurrencyFormControl;
